import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const Controls = ({ children, right, bottom, childrenWrapperClassName }) => (
	<div className={styles.controls}>
		<div className={styles.inner}>
			{children && (
				<div className={cx(styles.left, childrenWrapperClassName)}>
					{children}
				</div>
			)}
			{!!right && <div className={styles.right}>{right}</div>}
		</div>
		{!!bottom && <div className={styles.bottom}>{bottom}</div>}
	</div>
);

Controls.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]),
	right: PropTypes.node,
	bottom: PropTypes.node,
	childrenWrapperClassName: PropTypes.string
};

export default Controls;
